import { LANGUAGES } from '@guuru/languages-common';
import { FEATURES, PARTNER_FEATURES } from './Features';
import { NAMESPACES } from './Namespaces';

interface NamespaceFilters {
  showAll: boolean;
}

interface FeatureFilters {
  showAll: boolean;
  enabledFeatures: { [Key: string]: boolean };
}

interface LanguageFilters {
  activeLanguages: string[];
}

const formal = {
  key: 'formal',
  name: 'Formal Values',
};

const namespaces = Object.entries(NAMESPACES).map(([name, value]) => ({
  name,
  value: value.toLowerCase(),
}));

const FILTERS = {
  namespace: {
    key: 'namespace',
    label: 'Namespace',
    getFilters: ({ showAll }: NamespaceFilters) => (showAll ? namespaces : []),
  },

  feature: {
    key: 'feature',
    label: 'Feature',
    type: 'featureStatus',
    getFilters: ({ showAll, enabledFeatures }: FeatureFilters) => {
      const currentFilter = showAll ? FEATURES : PARTNER_FEATURES;
      return currentFilter.map(({ name, value }) => ({
        value,
        name,
        enabled: enabledFeatures[value] || false,
        showStatusDot: !showAll,
      }));
    },
  },

  languages: {
    key: 'language',
    label: 'Language',
    type: 'language',
    getFilters: ({ activeLanguages }: LanguageFilters) =>
      activeLanguages.map((key) => {
        const language = LANGUAGES[key as keyof typeof LANGUAGES];
        return {
          name: language ? language.name : key,
          value: key,
        };
      }),
  },

  searchText: {
    key: 'searchText',
  },

  language: {
    key: 'language',
  },

  keys: {
    key: 'keys',
  },
  formal,
  filterBy: {
    key: 'tanslationFilters',
    label: 'Show Only',
    filters: [formal],
  },
} as const;

// eslint-disable-next-line import/prefer-default-export
export { FILTERS };
